<template>
  <div class="container">
    <div class="row">
      <!-- .blog_content_left_fm -->
      <div class="blog_content_left_fm col-lg-3 col-lg-4 col-md-5 col-sm-5">
        <div class="blog_info">
          <div class="info_box">
            <p class="topimg_icon list f-bold">
              <img src="" /><span class="txt">{{ blogInfo.sgL_BlogName }}</span>
            </p>
            <div class="infobox">
              <div class="txt f-bold">{{$t('blog.userInfo.Briefintroduction')}}</div>
              <div class="description-text">
                {{ blogInfo.sgL_BlogContent }}
              </div>
              <div class="txt">
                <i class="fas fa-users"
                  >{{$t('blog.userInfo.Subscribernumber')}}: {{ blogInfo.sgL_SubscribeCount }}</i
                >
              </div>
            </div>
            <button
              type="button"
              class="btn btn-block btn-primary width"
              @click="sub"
            >
            {{$t('blog.userInfo.Subscriber')}}
            </button>
          </div>
        </div>

        <div class="blog_info">
          <div class="author">{{$t('blog.userInfo.authorhighest')}}</div>
          <div class="topic_box" v-for="(item, ix) in list1">
            <p class="topic_img"><img :src="item.sgL_UploadTempUrl" /></p>
            <div class="description">
              <span class="title">{{ item.sgL_Title }}</span>
              <span class="txt2">{{
                item.sgL_Content.replace(/<\/?.+?>/g, "").replace(/ /g, "")
              }}</span>
              <span class="postime">{{ item.sgL_CreateTimeE }}</span>
            </div>
            <hr />
          </div>
        </div>
      </div>
      <!-- /.END blog_content_left_fm -->

      <!-- blog_content_right_fm -->
      <div class="col-lg-8 col-md-7 pl-md-3">
        <div class="blog_content_right_fm">
          <div class="blog_content">
            <p class="blog_tap">{{$t('blog.userInfo.blong')}} {{ pageParams.total }}</p>
            <hr class="pb-2" />
            <div
              class="list_padding"
              v-for="(item, ix) in list"
              @click="
                $router.push({
                  name: 'blogDetail',
                  query: {
                    id: item.id,
                  },
                })
              "
            >
              <div class="list_post">
                <span class="images"
                  ><img :src="item.sgL_UploadTempUrl"
                /></span>
                <div class="list_info">
                  <p class="topimg_icon f-bold d-inline">
                    <img :src="item.sgL_UsersBLog" /><span class="txt">{{
                      item.sgL_BlogName
                    }}</span>
                  </p>
                  <p class="blog_count pb-2">
                    <span class="view"
                      ><i class="fas fa-eye">{{ item.sgL_ViewCount }}</i></span
                    >
                    <span class="like"
                      ><i class="fas fa-thumbs-up">{{
                        item.sgL_LikeCount
                      }}</i></span
                    >
                    <span class="share"
                      ><i class="fas fa-share">{{
                        item.sgL_SharCount
                      }}</i></span
                    >
                  </p>
                  <p class="list_title">
                    {{ item.sgL_Title }}
                  </p>
                  <span class="desciption fixheight">
                    {{
                      item.sgL_Content
                        .replace(/<\/?.+?>/g, "")
                        .replace(/ /g, "")
                    }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 頁碼 -->
            <div class="row my-5" style="width: 100%">
              <div class="col-12">
                <pagination
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  :pageSizes="pageParams.pageSizes"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
            <!-- /.頁碼 -->
          </div>
        </div>
      </div>
      <!-- /.END blog_content_right_fm -->
    </div>
  </div>
</template>

<script>
import pagination from "@/components/common/Page";
export default {
  components: { pagination },
  data() {
    return {
      list1: [],
      list: [],
      blogInfo: {},
      pageParams: {
        currentPage: 1,
        limit: 8,
        total: 0,
        pageshow: false,
        pageSizes: [8, 16, 24, 32],
      },
    };
  },
  created() {
    this.getData();
    this.GetAllByUserId();
  },
  methods: {
    sub() {
      if (this.loginUser === null) {
        this.$router.push({ name: "customerLogin" });
        return;
      }
      this.$api.blog
        .SubscribeCreate({
          sgL_SubscribeUsersId: this.$route.query.id,
        })
        .then((res) => {
          if (res.data.success) {
            this.GetIdByContent();
            this.$message.success(this.$t('message.operatesuccessfully'));
          } else {
            this.$message.error(res.data.error.message);
          }
        });
    },
    getData() {
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        sgL_UsersId: this.$route.query.id,
        sgL_IsShow: true,
      };
      this.$api.blog.GetAll(params).then((res) => {
        this.list = res.data.result.items;
        this.pageParams.total = res.data.result.totalCount;
      });
    },
    GetAllByUserId() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 4,
        sgL_UsersId: this.$route.query.id,
        sorting: "QueriesCount",
        sgL_IsShow: true,
      };
      this.$api.blog.GetAllByUserId(params).then((res) => {
        this.blogInfo = res.data.result;
        this.list1 = res.data.result.blogDto.items;
      });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getData();
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blog/userInfo.vue